<template>
  <div class="container">
    <h1>Ola mundo</h1>

    <span class="btn btn-success btn-default btn-file">
      COMEÇAR A GRAVAR
      <input
        type="file"
        ref="file"
        class="btn btn-success"
        v-on:change="sendMovie()"
        accept="video/*"
        name="answers[video]"
        id="capture"
        capture="camcorder"
      />
    </span>
    <video width="300px" v-if="file">
      <source :src="file" />
    </video>
  </div>
</template>

<script>
export default {
  data: () => ({
    file: false,
    url: false,
  }),
  methods: {
    sendMovie() {
      this.file = this.$refs.file.files[0];
      console.log(this.$refs.file);
      // let formData = new FormData();
      // let canvas = this.getThumbnail(blob);

      // formData.append("answers[video]", this.file);

      // canvas.toBlob(thumb => {
      //   formData.append("answers[thumbnail]", thumb);
      //   axios
      //     .post("/candidates/answers", formData, {
      //       headers: {
      //         "Content-Type": "multipart/form-data"
      //       }
      //     })
      //     .then(function(data) {
      //       console.log(data);
      //     })
      //     .catch(function(error) {
      //       console.log(error);
      //     });
      // }, "image/png");
    },
    getThumbnail(player) {
      let canvas = document.createElement("canvas");
      canvas.className = "hide";
      canvas.width = 320;
      canvas.height = 240;
      document.getElementsByTagName("body")[0].appendChild(canvas);

      // draw video frame
      let context = canvas.getContext("2d");
      context.drawImage(
        player.record().mediaElement,
        0,
        0,
        canvas.width,
        canvas.height
      );
      return canvas;
    },
  },
};
</script>
